module.exports = __webpack_public_path__ + "static/media/blacksquare.b66a73e4.png";